import { Provider as PaperProvider } from 'react-native-paper';
import { darkTheme, lightTheme } from './theme';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { useColorScheme } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import Routes from './routes/router';
import { store } from './redux/store';
import { Provider } from 'react-redux';

export default function App() {
  const colorScheme = useColorScheme();
  const osSelectedTheme = colorScheme === 'light' ? lightTheme : darkTheme;

  return (
    <Provider store={store}>
      <StatusBar style="light" />
      {/* Gesturehandler required for android bottomsheet */}
      <GestureHandlerRootView style={{ flex: 1 }}>
        <PaperProvider theme={osSelectedTheme}>
          <Routes />
        </PaperProvider>
      </GestureHandlerRootView>
    </Provider>
  );
}
